function formatMoney(cents) {
  const currency = window.Shopify?.currency?.active || 'USD';
  try {
    // Always US format ($X.XX) per cart-rework SPEC, regardless of browser locale.
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  } catch {
    return '$' + (cents / 100).toFixed(2);
  }
}

function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));
}

// The Captain Protection app injects its widget (#tm_cart / #tm_switch_btn) into
// EVERY cart container it finds — on the cart page that means both the main cart
// section AND the off-canvas cart drawer (#cart-drawer), producing TWO elements
// with id="tm_switch_btn" (invalid HTML + non-deterministic getElementById).
// We keep the visible main-cart instance as the single source of truth and
// neutralise the hidden drawer duplicate's id. No Captain add/remove logic or
// price math is changed — this only guarantees ONE active #tm_switch_btn.
function dedupeProtectionToggle() {
  const all = document.querySelectorAll('#tm_switch_btn');
  if (all.length < 2) return;
  all.forEach((el) => {
    const inMainCart = el.closest('.shopify-section--main-cart');
    if (!inMainCart && el.id === 'tm_switch_btn') {
      // Hidden drawer copy: drop the duplicate id (keep the app's own behaviour).
      el.id = 'tm_switch_btn--drawer';
    }
  });
}

// Resolve the active toggle, preferring the visible main-cart instance.
function getProtectionToggle() {
  dedupeProtectionToggle();
  return (
    document.querySelector('.shopify-section--main-cart #tm_switch_btn') ||
    document.getElementById('tm_switch_btn')
  );
}

function getInsuranceCents() {
  const cb = getProtectionToggle();
  const cachedCents = parseInt(localStorage.getItem('shipping_protection_cents')) || 0;

  if (cb) {
    const isChecked = cb.classList.contains('checked') || cb.checked;
    // Read the price from the SAME widget instance that owns the active toggle,
    // falling back to the first one if the structure isn't as expected.
    const tmCart = cb.closest('#tm_cart, .tm_cart');
    const priceEl = (tmCart && tmCart.querySelector('.tm_price')) || document.querySelector('#tm_cart .tm_price');

    // Safety check in case the DOM is partially injected
    if (isChecked && !priceEl) {
      console.log('CartDiscount: App injected but price not found yet. Using cache:', cachedCents);
      return cachedCents;
    }

    let currentCents = 0;
    if (priceEl && isChecked) {
      const raw = priceEl.textContent.replace(/[^0-9.]/g, '');
      const amount = parseFloat(raw);
      currentCents = isNaN(amount) ? 0 : Math.round(amount * 100);
    }
    
    // Sync with local storage
    if (currentCents !== cachedCents) {
      console.log('CartDiscount: Updating localStorage from', cachedCents, 'to', currentCents);
      localStorage.setItem('shipping_protection_cents', currentCents);
    }
    return currentCents;
  }

  // App not loaded yet, use cached price
  return cachedCents;
}

let isAdjusting = false;
function adjustSubtotal() {
  if (isAdjusting) return;
  const cartTotalEl = document.querySelector('.js-cart-total');
  if (!cartTotalEl) return;
  isAdjusting = true;
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const currentTotalEl = document.querySelector('.js-cart-total');
      if (currentTotalEl) {
        const newTotal = formatMoney(cart.total_price + getInsuranceCents());
        if (currentTotalEl.textContent !== newTotal) {
          currentTotalEl.textContent = newTotal;
        }
      }
    })
    .catch(() => {})
    .finally(() => {
      setTimeout(() => isAdjusting = false, 50);
    });
}

function autoEnableShippingProtection(cb) {
  if (window._captainAutoEnabled) return;
  window._captainAutoEnabled = true;

  const isChecked = cb.checked || cb.classList.contains('checked');
  if (!isChecked) {
    cb.click();
  }
}

function watchInsurance() {
  // Initial run with polling to wait for the app to load
  let attempts = 0;
  const maxAttempts = 30; // 15 seconds total

  function pollForApp() {
    const cb = getProtectionToggle();
    if (cb) {
      autoEnableShippingProtection(cb);
      // App found, adjust subtotal
      adjustSubtotal();
    } else if (attempts < maxAttempts) {
      attempts++;
      setTimeout(pollForApp, 500);
    }
  }

  pollForApp();

  // Watch for the checkbox changing state or the cart totals re-rendering
  const bodyObserver = new MutationObserver((mutations) => {
    let triggered = false;
    for (const m of mutations) {
      if (m.type === 'attributes' && m.target.id === 'tm_switch_btn' && (m.attributeName === 'class' || m.attributeName === 'checked')) {
        triggered = true;
        break;
      }
      if (m.type === 'childList' && m.target.classList && m.target.classList.contains('js-cart-total')) {
        triggered = true;
        break;
      }
      if (m.type === 'characterData' && m.target.parentElement && m.target.parentElement.classList && m.target.parentElement.classList.contains('js-cart-total')) {
        triggered = true;
        break;
      }
      if (m.addedNodes) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1) {
            if (n.classList && n.classList.contains('js-cart-total') || n.id === 'tm_switch_btn') {
              triggered = true;
              break;
            }
            if (n.querySelector && (n.querySelector('.js-cart-total') || n.querySelector('#tm_switch_btn'))) {
              triggered = true;
              break;
            }
          }
        }
      }
    }
    if (triggered) {
      adjustSubtotal();
    }
  });

  bodyObserver.observe(document.body, { 
    childList: true, 
    subtree: true, 
    attributes: true,
    attributeFilter: ['class', 'checked'],
    characterData: true
  });

  document.documentElement.addEventListener('cart:change', adjustSubtotal);
}

class CartDiscount {
  constructor(input) {
    this.input = input;

    const wrap = input.closest('.cart-form__discount');
    const form = input.closest('form');

    this.wrap         = wrap;
    this.applyBtn     = wrap.querySelector('.js-apply-discount');
    this.applyText    = wrap.querySelector('.js-apply-text');
    this.applySpinner = wrap.querySelector('.js-apply-spinner');
    this.appliedEl    = wrap.querySelector('.js-discount-applied');
    this.tagsEl       = wrap.querySelector('.js-discount-tags');
    this.tagTemplate  = wrap.querySelector('.js-discount-tag')?.cloneNode(true);
    this.errorEl      = wrap.querySelector('.js-discount-error');
    this.errorTextEl  = wrap.querySelector('.js-discount-error-text');

    // Discounts summary group (two-tier: header + per-promo sub-rows)
    this.discountsGroup   = form?.querySelector('.js-discounts-group');
    this.discountsTotalEl = form?.querySelector('.js-discounts-total');
    this.discountsSubrows = form?.querySelector('.js-discounts-subrows');
    this.cartTotalEl      = form?.querySelector('.js-cart-total');

    // Copy from the data layer (locales/en.default.json), with fallbacks.
    this.copy = window.cartDiscountStrings || {};

    this.applyBtn.addEventListener('click', () => this.apply());
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); this.apply(); }
    });
    // Remove buttons are delegated so dynamically-rendered tags work too.
    this.tagsEl?.addEventListener('click', (e) => {
      if (e.target.closest('.js-remove-discount')) this.remove();
    });
    // Clear the error state as soon as the shopper edits the code.
    this.input.addEventListener('input', () => {
      if (!this.errorEl?.hidden) this.clearError();
    });
  }

  t(key, replacements) {
    let str = this.copy[key] || '';
    if (replacements) {
      if ('code' in replacements)   str = str.replace(/__CODE__/g, replacements.code);
      if ('amount' in replacements) str = str.replace(/__AMOUNT__/g, replacements.amount);
    }
    return str;
  }

  async apply() {
    const code = this.input.value.trim().toUpperCase();
    if (!code) return;

    this.setLoading(true);
    this.clearError();

    try {
      const [preRes, applyRes] = await Promise.all([
        fetch('/cart.js'),
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: code })
        })
      ]);

      if (!applyRes.ok) throw new Error('api');

      const [preCart, postCart] = await Promise.all([preRes.json(), applyRes.json()]);

      this.handleResult(preCart, postCart, code);
    } catch {
      this.showError(this.t('generic') || 'Something went wrong. Please try again.');
    } finally {
      this.setLoading(false);
    }
  }

  handleResult(pre, post, code) {
    const codeApp = [
      ...(post.cart_level_discount_applications || []),
      ...(post.discount_applications || [])
    ].find(d =>
      d.type === 'discount_code' && (
        (d.title || '').toUpperCase() === code ||
        (d.key  || '').toUpperCase() === code
      )
    );

    const priceDropped      = post.total_price < pre.total_price;
    const discountIncreased = (post.total_discount || 0) > (pre.total_discount || 0);

    if (!codeApp && !priceDropped && !discountIncreased) {
      this.showError(this.t('invalid') || 'This code is invalid or has expired.');
      this.showToast('error', this.t('notApplied', { code: escapeHtml(code) }) || `${escapeHtml(code)} couldn’t be applied. Please check the code and try again.`);
      // Clear the bad code from the field so it does not linger (spec: clears the bad code).
      this.input.value = '';
      // Clear the bad code so it does not linger on the cart.
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      }).catch(() => {});
      return;
    }

    // Savings attributed to THIS code (for the success toast copy).
    let savings = codeApp?.total_allocated_amount || 0;
    if (!savings && priceDropped)      savings = pre.total_price - post.total_price;
    if (!savings && discountIncreased) savings = (post.total_discount || 0) - (pre.total_discount || 0);

    this.saveAttributes(code, savings);
    this.renderFromCart(post);
    this.input.value = '';
    this.showToast(
      'success',
      this.t('appliedToast', { code: escapeHtml(code), amount: formatMoney(savings) }) || `${escapeHtml(code)} applied → You saved ${formatMoney(savings)}`
    );
  }

  async remove() {
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: '',
          attributes: { discount_code_applied: '', discount_savings_amount: '0' }
        })
      });
      const cart = await res.json();
      this.renderFromCart(cart);
      this.input.value = '';
      this.clearError();
    } catch {}
  }

  // Collect every discount application (cart-level + line allocations) so the
  // two-promo / automatic / combinable states render as separate rows + tags.
  collectDiscounts(cart) {
    const out = [];
    const seen = new Set();
    // AJAX API exposes discount_applications at root (all types, indexed by line allocations)
    const allDiscApps = cart.discount_applications || cart.cart_level_discount_applications || [];
    const push = (title, amount) => {
      if (!title) return; // include zero-amount codes (e.g. free-shipping)
      const key = title.toUpperCase();
      if (seen.has(key)) return;
      seen.add(key);
      out.push({ title, amount: amount || 0 });
    };
    (cart.cart_level_discount_applications || []).forEach(d =>
      push(d.title || d.key, d.total_allocated_amount)
    );
    (cart.items || []).forEach(item =>
      (item.line_level_discount_allocations || item.discount_allocations || []).forEach(alloc => {
        // AJAX API uses discount_application_index, Liquid uses nested discount_application
        const da = alloc.discount_application || allDiscApps[alloc.discount_application_index] || {};
        push(da.title || da.code || alloc.title, alloc.amount);
      })
    );
    return out;
  }

  // Re-render cart UI via Shopify Section Rendering API — Liquid is the source
  // of truth for line-item discount pills, applied tags, and discounts group.
  refreshLineItems() {
    fetch('/cart', { headers: { Accept: 'text/html' } })
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Line items (discount pills per item)
        const newBody = doc.querySelector('.cart-items__body');
        const currentBody = document.querySelector('.shopify-section--main-cart .cart-items__body');
        if (newBody && currentBody) currentBody.innerHTML = newBody.innerHTML;

        // Applied code tags — update inner content only (preserve listener on this.tagsEl)
        const newApplied = doc.querySelector('.js-discount-applied');
        if (newApplied && this.appliedEl) {
          this.appliedEl.hidden = newApplied.hidden;
          const newTagsInner = newApplied.querySelector('.js-discount-tags');
          if (newTagsInner && this.tagsEl) this.tagsEl.innerHTML = newTagsInner.innerHTML;
        }

        // Discounts group in totals
        const newGroup = doc.querySelector('.js-discounts-group');
        if (newGroup && this.discountsGroup) {
          this.discountsGroup.hidden = newGroup.hidden;
          this.discountsGroup.innerHTML = newGroup.innerHTML;
        }
      })
      .catch(() => {});
  }

  // Single source of truth for the applied UI: re-render tags + summary rows
  // from the live cart, then patch the total.
  renderFromCart(cart) {
    const discounts = this.collectDiscounts(cart);
    // Savings-only subset for the totals group (free-shipping codes have amount 0)
    const withSavings = discounts.filter(d => d.amount > 0);
    const total = withSavings.reduce((sum, d) => sum + d.amount, 0);

    // ---- Applied tag stack (show for ANY applied code, even free-shipping) ----
    if (this.tagsEl) {
      this.tagsEl.innerHTML = '';
      discounts.forEach(({ title }) => {
        const tag = this.tagTemplate ? this.tagTemplate.cloneNode(true) : null;
        if (!tag) return;
        tag.dataset.code = title;
        const label = tag.querySelector('.js-discount-code-name');
        if (label) label.textContent = this.t('codeApplied', { code: title }) || `${title} applied`;
        this.tagsEl.appendChild(tag);
      });
    }
    if (this.appliedEl) this.appliedEl.hidden = discounts.length === 0;

    // ---- Discounts summary group (only when there are monetary savings) ----
    if (this.discountsSubrows) {
      this.discountsSubrows.innerHTML = '';
      withSavings.forEach(({ title, amount }) => {
        const row = document.createElement('div');
        row.className = 'cart-form__row cart-form__discounts-subrow h-stack justify-between';
        const lbl = document.createElement('span');
        lbl.className = 'cart-form__discounts-sublabel';
        lbl.textContent = this.t('promoSavings', { code: title }) || `Promo savings (${title})`;
        const amt = document.createElement('span');
        amt.className = 'cart-form__discounts-subamount';
        amt.textContent = `-${formatMoney(amount)}`;
        row.appendChild(lbl);
        row.appendChild(amt);
        this.discountsSubrows.appendChild(row);
      });
    }
    if (this.discountsTotalEl) this.discountsTotalEl.textContent = `-${formatMoney(total)}`;
    if (this.discountsGroup) {
      this.discountsGroup.hidden = total <= 0;
      if (total > 0) this.discountsGroup.classList.add('is-open');
    }

    // ---- Total today ----
    if (this.cartTotalEl) {
      this.cartTotalEl.textContent = formatMoney(cart.total_price + getInsuranceCents());
    }

    // ---- Per-line-item discount pills ----
    this.refreshLineItems();
  }

  saveAttributes(code, savings) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          discount_code_applied: code,
          discount_savings_amount: String(savings)
        }
      })
    }).catch(() => {});
  }

  showError(msg) {
    if (this.errorTextEl) this.errorTextEl.textContent = msg;
    if (this.errorEl)     this.errorEl.hidden = false;
    this.input.classList.add('is-error');
  }

  clearError() {
    if (this.errorEl) this.errorEl.hidden = true;
    this.input.classList.remove('is-error');
  }

  setLoading(on) {
    this.applyBtn.disabled = on;
    this.input.disabled    = on;
    this.applyBtn.classList.toggle('is-loading', on);
    if (this.applyText)    this.applyText.hidden    = on;
    if (this.applySpinner) this.applySpinner.hidden = !on;
  }

  // Bottom toast — success (#57FFA7) / error (#FF8577). Reuses the
  // .discount-toast structure but scoped + styled in cart-custom.css.
  showToast(type, message) {
    let toastEl = document.querySelector('.js-cart-discount-toast');
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cart-discount-toast js-cart-discount-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML = `
        <span class="cart-discount-toast__content">
          <span class="cart-discount-toast__icon" aria-hidden="true"></span>
          <span class="cart-discount-toast__text"></span>
        </span>
        <button type="button" class="cart-discount-toast__close js-cart-toast-close" aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5L5 15M5 5l10 10"/></svg>
        </button>`;
      document.body.appendChild(toastEl);
      toastEl.querySelector('.js-cart-toast-close').addEventListener('click', () => {
        toastEl.classList.remove('is-visible');
        if (window.cartDiscountToastTimeout) clearTimeout(window.cartDiscountToastTimeout);
      });
    }

    const success = type === 'success';
    const iconSvg = success
      ? '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="10" cy="10" r="8"/><path d="M6.5 10l2.5 2.5L14 7.5"/></svg>'
      : '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="10" cy="10" r="8"/><path d="M12.5 7.5l-5 5M7.5 7.5l5 5"/></svg>';

    toastEl.classList.toggle('is-error', !success);
    toastEl.querySelector('.cart-discount-toast__icon').innerHTML = iconSvg;
    toastEl.querySelector('.cart-discount-toast__text').innerHTML = message;
    toastEl.classList.add('is-visible');

    if (window.cartDiscountToastTimeout) clearTimeout(window.cartDiscountToastTimeout);
    window.cartDiscountToastTimeout = setTimeout(() => {
      toastEl.classList.remove('is-visible');
    }, 4000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="cart-discount-code-"]').forEach(input => {
    new CartDiscount(input);
  });
  watchInsurance();
});
